import React, { useState, useRef, FC, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
  ListItemButton,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import { TermoAceito } from "src/store/termos/types";
import "./styles.css"
import theme from "src/theme/light";

interface TermosAtivosProps {
  termos: TermoAceito[];
  open: boolean;
}
const useStyles = makeStyles((_theme) => ({
  topHeaderContainer: {
    backgroundColor: "#ffffff",
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 3),
    width: '100%',
    boxSizing: 'border-box',
  },
  headerText: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: 'left',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: "85vh",
    borderRadius: 4,
    overflow: "hidden",
    bgcolor: "#ffffff",
    boxShadow: theme.shadows[1], 
  }
}));

const TermoListagem: FC<TermosAtivosProps> = ({ termos }) => {
  const [termoSelecionado, setTermoSelecionado] = useState(termos[0]);
  const scrollBoxRef = useRef<HTMLDivElement>(null);
  const classes = useStyles();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(()=>{
    setTermoSelecionado(termos[0])
  },[termos])

  return (
    <Box className={`${classes.mainContainer} termos-container`}>
      <Box className={classes.topHeaderContainer}>
        <Typography 
          variant="h5" 
          className={classes.headerText}>
          Termos aceitos
        </Typography>
      </Box>
      <Box className="termos-root">
        <Box className="termos-list">
          <List 
            disablePadding
            style={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 100px)",
            }}
          >
            {termos.map((termo, index) => (
              <ListItem disablePadding key={termo.id}>
                <ListItemButton
                  selected={termoSelecionado?.id === termo?.id}
                  onClick={() => {
                    setTermoSelecionado(termo);
                    if (scrollBoxRef.current) scrollBoxRef.current.scrollTop = 0;
                  }}
                  sx={{
                    transition: "background-color 0.2s",
                    mb: "15px",
                  }}
                >
                  <ListItemIcon>
                    <Box className="termo-list-item">
                      {index + 1}
                    </Box>
                  </ListItemIcon>

                  <ListItemText
                    primary={termo.versao}
                    primaryTypographyProps={{
                      fontSize: 14,
                      color: "#333",
                    }}
                  />
                </ListItemButton>
              </ListItem>
              ))}
          </List>
        </Box>
        <Box className="termo-item">
          {termoSelecionado?.data_confirmacao_termo && termoSelecionado?.termo_aceito_por && (
            <FormControlLabel 
              style={!isMobile ? {paddingLeft: "20px", marginBottom: "10px"} : {}}
              control={ <Checkbox disabled checked /> } 
              label={`Aceito em - ${moment(termoSelecionado?.data_confirmacao_termo).format("DD/MM/YYYY - HH:mm:ss")} por ${termoSelecionado?.termo_aceito_por}`} 
            />
          )}  
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: "bold",
                marginBottom: 16,
                marginTop: isMobile ? 16 : 0,
                color: "#333",
                textTransform: "uppercase",
                alignSelf: "start",
                paddingLeft: !isMobile ? 20 : 0,
              }}
            >
              {termoSelecionado?.versao}
            </Typography>
            <Box
              ref={scrollBoxRef}
              flex={1}
              overflow="auto"
              style={{
                padding: !isMobile ? 20 : 0,
                textAlign: "justify",
                lineHeight: 1.6,
              }}
            >
              <Typography
                variant="body2"
                style={{
                  whiteSpace: "pre-line",
                  color: "#333",
                }}>
                  <Box
                    className="content-termos"
                    dangerouslySetInnerHTML={{ __html: termoSelecionado?.descricao || "" }}
                  />
              </Typography>
            </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { TermoListagem };
